import React, {useEffect, useState} from 'react';
import {loadSticker} from "../../../store/entities/stickers/actions";
import * as _ from 'lodash';
import * as moment from "moment";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import styles from './style.css';
import StickersComponentsMediaPhoto from "../../components/media-photo";
import {getDisplayedUser} from "../../../domain/services/StickerHelpers";
import StickersComponentsMediaAudio from "../../components/media-audio";
import StickersComponentsMediaVideo from "../../components/media-video";
import StickersComponentsStickerComments from "../../components/sticker-comments";
// import StickersComponentsStickerControls from "../../components/bubble-container";
import Icon from "../../../../icons/Icon";
import {StickerFormatEnum} from "../../../domain/enums/StickerFormatEnum";
import {
    authUserStateSelector, currentUserInfoSelector, moderatorModeSelector,
} from "../../../../auth/store/auth-user/selectors";
import Div100vh from "../../../../uq-ui/components/div-100";
import LayoutComponentsLoaderProcessing from "../../../../layout/ui/components/loader-processing";
import {Fragment} from "react";
import { stickerShowStateSelector } from "../../../store/sticker-show/selectors";
import {getTextDirection} from "../../../../uq-ui/helpers/messageDirection";
// import i18n from '../../../../../i18n';
import TextWithLinks from '../../../../uq-ui/components/text-with-links';
import ThemesScrollbar from "../../../../layout/ui/components/themed-scrollbar";
import linearTranslation from "../../../../../utils/linear-translation";
import {useHistory, useParams} from "react-router";
import {themesSelector} from "../../../store/dictionaries/selectors";
import {deleteStickerItem} from "../../../store/entities/sticker-items/actions";
import ConfirmModal from "../../../../uq-ui/components/confirm-modal";
import UQButton from "../../../../uq-ui/components/button";
import BubbleContainer from "../../components/bubble-container";
import StickersComponentsScannerHeader from "../../components/scanner-header";
import {useStickerItem} from "../../../store/sticker-show/hooks";
import UiIcon from "../../../../uq-ui/components/ui-icon";


export default function StickerItemScreensShow(props) {
    const {id: stickerId, itemId: stickerItemId} = useParams()
    const currentUser = useSelector(currentUserInfoSelector);
    const {t} = useTranslation("scr-show-sticker-item")
    const authState = useSelector(authUserStateSelector);
    const showState = useSelector(stickerShowStateSelector);
    const themes = useSelector(themesSelector);
    const [stickerItem, stickerItemStatus] = useStickerItem(stickerId, stickerItemId)
    const history = useHistory();
    const dispatch: (any) => Promise<any> = useDispatch();
    const [confirmStickerDelete, setConfirmStickerDelete] = useState<boolean>(false);
    // Opened by its link, the moment's sticker is not in the store yet, and the
    // page look (memorial or greeting) follows the loaded sticker.
    const stickerLoaded = useSelector((state: any) =>
        state.stickers.entities.stickers.fetchState?.[stickerId]?.status === 'succeeded');
    useEffect(() => {
        if (stickerId && !stickerLoaded) {
            dispatch(loadSticker(stickerId));
        }
    }, [stickerId]); // eslint-disable-line react-hooks/exhaustive-deps
    // Moderator mode (sidebar toggle) adds deleting on any sticker; owners of a
    // memorial sticker can always delete their own.
    const canModerate = useSelector(moderatorModeSelector);
    const isMySticker = currentUser.id === stickerItem?.from?.id
    // Content decisions (owner controls, photo height) follow the item's own
    // type; colors come from the app theme tokens.
    const isStickerTypeMemorial = stickerItem?.type === 'MEMORIAL';

    if (stickerItemStatus === 'failed'){
        history.push(`/stickers/${stickerId}`);
    }

    const onBack = () => {
        history.push(`/stickers/${stickerId}`);
    }

    const renderDate = () => {
        const dateString = getDateString();
        if (dateString) {
            return (<div className={styles.dateString}>{dateString}</div>);
        }
        return null;
    }

    const renderAuthor = () => {
        return (<div className={styles.author}>{getAuthorString()}</div>)
    }

    const getAuthorString = () => {
        const displayedUser = getDisplayedUser(stickerItem);
        return displayedUser.display_name;
    }

    const getDateString = () => {
        if (!stickerItem) {
            return
        }

        const date = stickerItem.configured_date;
        if (date) {
            return moment(date).format('MMM YYYY');
        }
        return null;
    }

    const renderGreeting = () => {
        if (!stickerItem) {
            return
        }

        const value = linearTranslation(window.innerHeight, 550, 80, 750, 160);
        let maxHeight = `${value}px`;
        const {greeting_text} = stickerItem;
        const hasLinks = greeting_text.search(/https/ig) === -1;
        const direction = getTextDirection(greeting_text);
        // @ts-ignore
        return (<ThemesScrollbar maxHeight={maxHeight} direction={direction}>
                {hasLinks ?
                    greeting_text
                    :
                    <TextWithLinks linkStyle={{color: 'var(--c-accent)', textDecorationLine: 'underline', cursor: 'default'}}
                                   text={greeting_text}/>
                }
            </ThemesScrollbar>
        );
    }

    const renderTextContent = () => {
        if (!stickerItem) {
            return
        }

        const {greeting_text, views_count} = stickerItem;
        const hasText = greeting_text != null && greeting_text !== '';
        const direction = getTextDirection(greeting_text || '');
        // const appDirection = i18n.dir();

        if (hasText) {
            return (
                <Fragment>
                    <div style={{position: "relative"}}>
                        <div className={styles.stickerText} style={{direction: direction}}>
                            {renderGreeting()}
                        </div>
                    </div>
                    <div className={styles.authorDateContainer}>
                        <div className={styles.authorDateInner}>
                            {getAuthorString() && renderAuthor()}
                            {renderDate()}
                        </div>
                        {/*<div style={{direction: appDirection}} className={styles.scansCounterContainer}>*/}
                        {/*    <Icon name="CounterEye" width="16px" height="9px" className={styles.scansCounterIcon}/>*/}
                        {/*    <div*/}
                        {/*        className={styles.scansCounterText}>{` ${views_count || '0'} ${t('views')}`}</div>*/}
                        {/*</div>*/}
                    </div>
                </Fragment>
            )
        }

        const dateAuthor = getAuthorString() ? `${getAuthorString()}, ${getDateString()}` : `${getDateString()}`;
        return (
            <div className={styles.dateAndCountContainer} style={{direction: direction}}>
                <div className={styles.scansCounterContainer}>
                    <UiIcon name="eye" size={16} color="var(--c-text-muted)" className={styles.scansCounterIcon}/>
                    <div className={styles.scansCounterText}>{` ${views_count || '0'} ${t('views')}`}</div>
                </div>
                <div className={styles.dateString}>{dateAuthor}</div>
            </div>
        );
    }

    // @ts-ignore
    const renderTheme = () => {
        if (!isGreetingType() || !stickerItem) {
            return <div/>
        }

        const themeId = stickerItem.template;
        const theme = themes.find((tpl) => Number(tpl.id) === Number(themeId));

        if (theme) {
            return (
                <img src={theme.show.source.srcSvg} className={styles.theme}/>
            )
        }
        return null;
    }

    const renderStickerMedia = () => {
        if (!stickerItem) {
            return
        }

        switch (stickerItem.format) {
            case StickerFormatEnum.Image:
                const imageSource = _.get(stickerItem, 'photo.original.source');
                return (<StickersComponentsMediaPhoto source={imageSource} isMemorial={ isStickerTypeMemorial } />);
            case StickerFormatEnum.Audio:
                const audioSource = _.get(stickerItem, 'audio.original.source');
                const audioDuration = _.get(stickerItem, 'audio.duration');
                if (audioDuration != null && audioSource != null) {
                    return (
                        <StickersComponentsMediaAudio
                            source={audioSource}
                            duration={audioDuration}/>
                    );
                }
                return null;
            case StickerFormatEnum.Video:
                const videoSource = _.get(stickerItem, 'video.original.source');
                const videoDuration = _.get(stickerItem, 'video.duration');
                const videoThumbnail = _.get(stickerItem, 'video.thumbnail.source');
                return (<StickersComponentsMediaVideo
                    duration={videoDuration}
                    thumbnail={videoThumbnail}
                    source={videoSource}/>);
            default:
                return null;
        }
    }

    const isGreetingType = () => {
        return _.get(stickerItem, 'type') === "GREETING";
    };

    const renderComments = () => {
        if (!isGreetingType()) {
            return <div/>
        }

        return <StickersComponentsStickerComments
            unreadCount={showState.unreadCommentsCount}
            comments={showState.comments}
            containerStyle={{marginTop: '-44px'}}/>
    };

    const renderControls = () => {
        // Owners delete on memorial stickers only; moderators/admins on any.
        if (!(canModerate || (isMySticker && isStickerTypeMemorial))) {
            return <></>
        }

        return <BubbleContainer
            title={t('controlsTitle')}
            innerStyle={{alignItems: "flex-start"}}
        >
            <div className={`${styles.controlsText} font-text`}>
                {t('controlsAdvancedPermissions')}
            </div>
            <UQButton label={t('deleteButton')}
                      theme={'danger'}
                      containerClass={styles.attachFloatButton}
                      onPress={() => {
                          setConfirmStickerDelete(true)
                      }}/>
        </BubbleContainer>
    };

    const renderStickerShow = () => {
        return (
            <Fragment>
                <div className={styles.sticker}>
                    <Div100vh style={{minHeight: '100rvh', position: 'relative'}} withResize={false}>
                        <div className={styles.stickerTop}>
                            <div className={styles.stickerMediaContainer}>
                                {authState.isSessionLoaded && renderStickerMedia()}
                            </div>
                            {renderTextContent()}
                        </div>
                        {renderTheme()}
                    </Div100vh>
                    {renderComments()}
                    {renderControls()}
                </div>
            </Fragment>
        )
    }

    return <Fragment>
        <ConfirmModal
            show={confirmStickerDelete}
            title={t('deleteTitle')}
            styles={{zIndex: 105}}
            showConfirmBtn={false}
            onClose={() => setConfirmStickerDelete(false)}
        >
            <div className={styles.deleteModelContainer}>
                {t('deleteMessage')}
                <UQButton label={t('deleteButton')}
                          containerClass={styles.attachFloatButton}
                          theme={'danger'}
                          onPress={() => {
                              dispatch(deleteStickerItem(stickerItem))
                                  .then(onBack);
                              setConfirmStickerDelete(false);
                          }}/>
            </div>
        </ConfirmModal>
        {/*
             // @ts-ignore */}
        <StickersComponentsScannerHeader theme="brand"
                                         title={t('headerTitle')}
                                         showLogo={true}
                                         showBackBtn={true}
                                         onBack={onBack}/>
        <Div100vh className={styles.scrollView} style={{minHeight: '100rvh'}}>
            <div className={styles.page}>
                {
                    showState.formErrors.server && (
                        <div className={styles.modal}>
                            <div className={styles.formError}>
                                <UiIcon name="alert" size={16} color="var(--c-danger)"/>
                                <div className={styles.formErrorText}>{t('serverError')}</div>
                            </div>
                        </div>
                    )}
                {/* Loader until the item fetch resolves - the not-found splash
                    below must never flash while the answer is still unknown. */}
                <LayoutComponentsLoaderProcessing opacity={1}
                                                  show={!stickerItem && stickerItemStatus !== 'succeeded'}/>
                {
                    stickerItem
                    && renderStickerShow()}
                {
                    stickerItemStatus === 'succeeded'
                    && !showState.isStickerConfigured
                    && !stickerItem && (
                        <div className={styles.notConfiguredSplash}>
                            <span className={styles.notConfiguredText}>{t('stickerNotConfigured')}</span>
                        </div>
                    )}
            </div>
        </Div100vh>
    </Fragment>
}
